import { AwmFundParams } from '@repo/accounts-types'
import { createDownloadSlice } from '@repo/core'

export const { actions: awmFundsDownloadActions, reducer: awmFundsDownloadReducer } =
  createDownloadSlice<AwmFundParams>('@accounts/detail/read/awmFundsDownload')
